/**
 * i18n configuration for localization in the Vue.js application.
 *
 * File: \I18n.ts
 * Created Date: Monday, June 17th 2024, 10:17:40
 * Author: Herrmann Sascha (LDC)
 * -----
 * Last Modified: September 18th 2024, 10:59:17
 * Modified By: Herrmann Sascha (LDC)
 * -----
 * Copyright (c) 2024-2024 Liebherr-Digital Development Center GmbH
 */

import { I18n, createI18n } from 'vue-i18n';

export const i18n: I18n = createI18n({
  legacy: false,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  warnHtmlMessage: false,
  globalInjection: true
});
